import classNames from 'classnames/bind';
import React from 'react';

import styles from './NotFound.module.scss';

import ContainerFullHeight from '@/components/ui/ContainerFullHeight';
import { PrimaryButton } from '@/components/ui/kit/Button';

const cx = classNames.bind(styles);

const NotFound = () => {
  const reload = () => {
    window.location.replace('/');
  };

  return (
    <ContainerFullHeight className={cx('container')}>
      <div className={cx('form')}>
        <div className={cx('limiter')}>
          <div className={cx('message')}>
            That page doesn't exist.
            <br />
            <span className={cx('accent')}>Please check the address again.</span>
            <br />
            If it persists, contact the administrator.
          </div>
          <PrimaryButton text="Reload" type="wide" accent onClick={reload} />
        </div>
      </div>
    </ContainerFullHeight>
  );
};

export default NotFound;
